let audio = null;

export function playNotificationSound() {
  try {
    if (!audio) {
      audio = new Audio("/notification.mp3");
      audio.volume = 0.5;
    }
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {
    // Blocked before first user interaction — silently skip
  }
}
